import React from 'react';

const SIZE_CLASS = {
  header: 'h-10 w-10 shrink-0 rounded-xl object-cover',
  card: 'h-24 w-24 shrink-0 rounded-2xl object-cover shadow-saas ring-1 ring-hairline/40',
  hero: 'h-24 w-24 shrink-0 rounded-2xl object-cover shadow-[0_20px_50px_-20px_rgba(0,0,0,0.45)] ring-2 ring-white/20 md:h-32 md:w-32',
};

/** آواتار / لوگوی بازرگان در هدر، کارت فهرست و هیرو */
export default function TraderBrandMark({ imageUrl, initial, avatar, size = 'header' }) {
  const imgClass = SIZE_CLASS[size] || SIZE_CLASS.header;

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        className={imgClass}
        loading="eager"
        decoding="async"
      />
    );
  }

  return (
    <div className={avatar.className} style={avatar.style}>
      {initial}
    </div>
  );
}
